export const COURSE_PAUSE_REQUEST_STATUSES = {
  requested: 'requested',
  pending: 'pending',
  accepted: 'accepted',
  rejected: 'rejected',
  cancelled: 'cancelled',
  scheduledAccept: 'scheduled_accept',
  scheduledResume: 'scheduled_resume',
};
